import React from 'react'
import '../Loader/Loader.css'

export default function Loader() {
    return (
        <div className='loader'></div>
    )
}
